<template>
  <div class="hour-content" :class="[type ? `hour-content-${type}` : '']" :style="widthStyle">
    <img class="aqi-img" :class="{isOk : isOk}" v-show="svg" :src="svg" :style="itemStyle" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      scrollIndex: this.hourIndex,
      topList: [],
      nameList: [],
      svg: ''
    }
  },
  props: {
    aqiHour: Object | Array,
    hourIndex: Number,
    r: Number | String,
    isOk: Boolean,
    cur: Number || String,
    next: Object,
    isCur: Boolean,
    type: String
  },
  computed: {
    widthStyle() {
      return {
        width: (this.aqiHour.length - this.cur) * 116 + 'px'
      }
    },
    itemStyle() {
      return {
        height: '81px',
        width:this.aqiHour.length*58 + 'px',
        opacity:this.isCur?0.2:0.1
      }
    }
  },
  created() {
    var t = this;
    setTimeout(function() {
      if (t.aqiHour) {
        var e = t.getSVG(t.aqiHour), n = e.svg, r = e.topList, i = e.nameList, o = encodeURI(n).replace(/'/g, "%27").replace('#', '%23');
        t.topList = r;
        t.nameList = i;
        t.svg = o;
      }
    }, 100);
  },
  methods: {
    getSVG: function(t) {
      for (var e = -100, n = 100, r = [], i = 0; i < t.length; i++) {
          var o = Number(t[i].tmp);
          o > e && (e = o), n > o && (n = o), r.push({
              x: 58 + 116 * i,
              y: t[i].y
          });
      }
      r.push({
          x: 116 * r.length,
          y: r[r.length - 1].y - 2
      }), this.genControlPoint(r);
      for (var a = "data:image/svg+xml,<svg width='" + 116 * t.length + "' height='160'  xmlns='http://www.w3.org/2000/svg'>", h = this.genPath(r, "#fff"), y = (this.genCircle(r, "#000000"),
      this.genLine(r, "#000000"), []), g = [], s = 0; s < t.length; s++) y.push(110 - r[s].y),
      t[s].hour && g.push(t[s].hour);
      return {
          topList: y,
          nameList: g,
          svg: "" + a + h + "</svg>"
      };
  },
  genCircle: function(t, e) {
      for (var n = [], r = 0; r < t.length; r++) {
          var i = t[r], o = i.x, a = i.y;
          n.push("<circle cx='" + o + "' cy='" + a + "' r='4' stroke-width='0' fill='" + e + "' />");
      }
      return n.join("");
  },
  genLine: function(t, e) {
      for (var n = "<path d='M0 " + t[0].y, r = "' stroke-width='1' fill='none' stroke='" + e + "'/>", i = "L" + t[0].x + " " + t[0].y, o = 1; o < t.length; o++) {
          var a = t[o - 1], h = a.A, y = a.B, g = t[o], s = g.x, l = g.y;
          i += " C" + h.x + " " + h.y + " " + y.x + " " + y.y + " " + s + " " + l;
      }
      var u = t[t.length - 1];
      return i += " L" + (u.x + 58) + " " + u.y, "" + n + i + r;
  },
  genPath: function(t, e) {
      for (var n = "Z' stroke-width='0' fill='" + e + "'/>", r = "L0 " + t[0].y + " L0 " + t[0].y, i = 1; i < t.length; i++) {
          var o = t[i - 1], a = o.A, h = o.B, y = t[i], g = y.x, s = y.y;
          r += " C" + a.x + " " + a.y + " " + h.x + " " + h.y + " " + g + " " + s;
      }
      var l = t[t.length - 1];
      return "<path d='M0 0 " + (r += " L" + (l.x + 58) + " " + l.y + " L" + (l.x + 58) + " 0") + n;
  },
  genControlPoint: function(t, e) {
    if (!(t.length < 2)) for (var n = 0; n < t.length - 1; n++) {
      var r = t[n], i = 0 === n ? {
          x: 0,
          y: r.y
      } : t[n - 1], o = t[n + 1], a = n === t.length - 2 ? {
          x: o.x + 58,
          y: o.y
      } : t[n + 2], h = r.x + .25 * (o.x - i.x), y = r.y + .25 * (o.y - i.y), g = o.x - .25 * (a.x - r.x), s = o.y - .25 * (a.y - r.y);
      r.A = {
          x: h,
          y: y
      }, r.B = {
          x: g,
          y: s
      };
     }
    }
  }
}
</script>
<style scoped>
.aqi-img {
  transform: scaleY(-1);
  position: absolute;
  left: 0;
  /* z-index: -1; */
  height: 80px;
  width: 100%;
  opacity: 0.1;
}

.aqi-img.isOk {
  margin-left: -56px;
}

.aqi-item {
  flex: 1;
  height: 80px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
}

.hour-content {
  overflow: hidden;
  position: relative;
  align-items: stretch;
  height: 80px;
  display: flex;
  flex-direction: row;
}

.hour-content-qt:after {
  display: block;
  position: absolute;
  top: 2px;
  left: 0;
  content: '';
  width: 1px;
  height: 98px;
  background: #00446c;
}
.hour-content-yt:after {
  display: block;
  position: absolute;
  top: 2px;
  left: 0;
  content: '';
  width: 1px;
  height: 98px;
  background: #091a1a;
}
.hour-content-dy:after {
  display: block;
  position: absolute;
  top: 2px;
  left: 0;
  content: '';
  width: 1px;
  height: 98px;
  background: #025989;
}
.hour-content-xy:after {
  display: block;
  position: absolute;
  top: 2px;
  left: 0;
  content: '';
  width: 1px;
  height: 98px;
  background: #0c1412;
}

.items {
  align-items: stretch;
  height: 25px;
  display: flex;
  flex-direction: row;
  font-size: 11px;
  color: #666666;
  padding-top: 16px;
}

.hour {
  flex: 1;
  display: flex;
  padding-left: 15px;
  justify-content: flex-start;
}

.tip {
  position: absolute;
  left: 17px;
  width: 52px;
  height: 24px;
  justify-content: center;
  display: flex;
  align-items: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  color: white;
  font-size: 12px;
}

.tip-last {
  position: absolute;
  right: 17px;
  width: 52px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 12px;
  color: white;
  font-size: 12px;
}
</style>
